module.exports = __webpack_public_path__ + "img/img_box1.a6240e2f.png";